import { useState } from "react";
import { getWheelRaffleErrorMessage } from "entities/wheel-raffle";
import { getErrorCode } from "shared/utils";
import { useDrawWheelRaffleMutation } from "../api/drawWheelRaffleApi";

// Повторный клик — не ошибка: розыгрыш уже проведён, экран обновится сам.
const SILENT_CODES = new Set(["already_drawn"]);

export const useDrawRaffle = (raffleId: number, onDrawn?: () => void) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const [drawRaffle, { isLoading, error }] = useDrawWheelRaffleMutation();

  const code = getErrorCode(error);
  const errorMessage =
    code && SILENT_CODES.has(code) ? null : getWheelRaffleErrorMessage(error);

  const confirm = async () => {
    const result = await drawRaffle(raffleId);
    const isAlreadyDrawn = getErrorCode(result.error) === "already_drawn";
    if (result.data || isAlreadyDrawn) onDrawn?.();
  };

  return {
    isConfirming,
    startConfirm: () => setIsConfirming(true),
    cancelConfirm: () => setIsConfirming(false),
    confirm,
    isDrawing: isLoading,
    errorMessage,
  };
};
